import { Either } from "monet";

/**
 * @description Шлюз врачей.
 * @param {import('axios').AxiosStatic} axios
 * @constructor 
 */
export default function DoctorGateway(axios) {
  /**
   * @description Показать список врачей.
   * @returns {Promise<Either>}
   */
  this.viewList = () => axios
    .get('/appointment-booking-widget-api/doctors')
    .then((response) => Either.right(response.data.data));

  /**
   * @description Показать слоты записи врача.
   * @param {string} doctorId Идентификатор врача.
   * @returns {Promise<Either>}
   */
  this.viewAppointmentSlots = (doctorId) => axios
    .get(`/appointment-booking-widget-api/doctors/${doctorId}/appointment-slots`)
    .then((response) => Either.right(response.data.data));
};